import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const LogoutContent = ({ layout, titleTag: TitleTag }) => {
  return (
    <Fragment>
      <div className="psi-logout-mark mb-4">PSI</div>
      <TitleTag>Seans yakunlandi</TitleTag>
      <p>`p-admin` sessiyasi yopildi. Tizimga qayta kirish uchun login sahifasiga o`ting.</p>
      <Button tag={Link} color="primary" size="sm" className="mt-3" to={`/authentication/${layout}/login`}>
        <FontAwesomeIcon icon="chevron-left" transform="shrink-4 down-1" className="mr-1" />
        Login ga qaytish
      </Button>
    </Fragment>
  );
};

LogoutContent.propTypes = {
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

LogoutContent.defaultProps = {
  layout: 'basic',
  titleTag: 'h4'
};

export default LogoutContent;
